export default {
  title: {
    list: 'Workout log',
    edit: 'Log detgails',
  },
  form: {
    message: 'Comments',
    loggedAt: 'Logged at',
    result: {
      BoulderGrade: 'Average grade',
      RouteGrade: 'Average grade',
      Resistance: 'How much weight added',
      Weight: 'How much weight used',
      Duration: 'How long was this session',
      AttemptCount: 'Number of routes/attempts?',
      RepeatCount: 'Number of repetitions',
      Difficulty: 'Chosen difficulty',
    },
    submit: 'Save',
  },
  button: {
    create: 'Log a workout',
  },
  table: {
    message: 'comment',
    loggedAt: 'date',
    result: {
      BoulderGrade: 'grade',
      RouteGrade: 'grade',
      Resistance: 'weight',
      Weight: 'weight',
      Duration: 'duration',
      AttemptCount: 'routes/attempts?',
      RepeatCount: 'repetitions',
      Difficulty: 'difficulty',
    },
  },
  delete: {
    button: 'Delete this log',
    confirm: {
      title: 'Confirm the deletion of the log',
      submit: 'Delete',
    },
  },
}
